import React, { useContext } from "react";
import { css } from "emotion";
import { BuildContext } from "../../context/BuildSpotlightState";
import GenericButton from "../GenericButton";
import { boxStyles } from "../../styles/theme";

const NextButton = ({ handleClick, disabled }) => {
  return (
    <div className={container}>
      <GenericButton
        style="next-btn"
        handleClick={handleClick}
        text="Next"
        disabled={disabled}
      />
    </div>
  );
};

export default NextButton;

const container = css`
  padding: ${boxStyles.standardPadding};
  width: 100%;
  .next-btn {
    width: auto;
    padding: 8px 20px;
    margin: auto;
    min-width: 140px;
    margin-top: 20px;
  }
`;
